// Visual primitives used by the interview dialogue and JSON lead magnets.
export const chatStyles = {
	messageWidth: 'mx-auto w-full max-w-[720px] px-6',
	messageBody:
		'min-w-0 text-base leading-[1.6] text-black [&>:first-child]:mt-0',
	userBubble:
		'whitespace-pre-wrap rounded-2xl bg-[#E5E7EB] px-4 py-3 text-base leading-[1.55] text-black',
	composer:
		'relative rounded-2xl border border-gray-4 bg-white px-4 pb-2.5 pt-3.5 transition-[border-color,box-shadow] duration-150 focus-within:shadow-[0_0_0_3px_rgba(31,30,27,0.05)]',
	field:
		'block max-h-[124px] min-h-[44px] w-full resize-none overflow-y-auto border-none bg-transparent font-sans text-base leading-[1.55] text-black outline-none disabled:cursor-not-allowed disabled:placeholder:text-gray-4',
	sendButton:
		'flex size-8 items-center justify-center rounded-lg border-none transition-all duration-150',
	sendActive: 'cursor-pointer bg-black text-white',
	sendEmpty: 'cursor-not-allowed bg-gray-5 text-gray-4',
	actions:
		'grid w-full grid-cols-2 gap-2 [&>*]:h-auto [&>*]:min-h-9 [&>*]:w-full [&>*]:min-w-0 [&>*]:justify-center [&>*]:px-3 [&>*]:py-2 [&>*]:text-center [&>:last-child:nth-child(odd)]:col-span-2',
};
